import { useAuth0 } from '@auth0/auth0-react';
import type { Private } from '@seek/indie-api-types';
import React, { type ReactNode, useContext, useEffect, useState } from 'react';

import { useApi } from 'src/api';

const ctx = React.createContext<Private.GrantsPayload | null>(null);

export const GrantsProvider = ({ children }: { children: ReactNode }) => {
  const api = useApi();
  const { isAuthenticated } = useAuth0();
  const [grants, setGrants] = useState<Private.GrantsPayload | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setGrants(null);
      return;
    }

    let cancelled = false;

    api.grants.list().then((response) => {
      if (cancelled) {
        return;
      }

      setGrants(response);
    });

    return () => {
      cancelled = true;
    };
  }, [api, isAuthenticated]);

  return <ctx.Provider value={grants}>{children}</ctx.Provider>;
};

export const useGrants = () => useContext(ctx);
